export default {
      id: "ic_info_circle_bordered_black-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic_info_circle_bordered_black-usage",
      toString: function () {
        return this.url;
      }
    }